import { BASE_BACKEND_URL } from '../../../auth'
import { authJson, buildQuery } from '../../services/shared/authJson'

export async function fetchRoles(params = {}) {
  const { includeInactive = false, ...rest } = params
  const query = includeInactive ? rest : { status: 'active', ...rest }
  return authJson(`${BASE_BACKEND_URL}/rbac/roles${buildQuery(query)}`)
}

export async function fetchRole(id) {
  return authJson(`${BASE_BACKEND_URL}/rbac/roles/${id}`)
}

export async function createRole(payload, options = {}) {
  return authJson(`${BASE_BACKEND_URL}/rbac/roles`, {
    ...options,
    method: 'POST',
    body: JSON.stringify(payload)
  })
}

export async function updateRole(id, payload, options = {}) {
  return authJson(`${BASE_BACKEND_URL}/rbac/roles/${id}`, {
    ...options,
    method: 'PUT',
    body: JSON.stringify(payload)
  })
}

export async function fetchRoleUsers(roleId, params = {}) {
  return authJson(`${BASE_BACKEND_URL}/rbac/roles/${roleId}/users${buildQuery(params)}`)
}

export async function fetchRoleHistory(roleId, params = {}) {
  return authJson(`${BASE_BACKEND_URL}/rbac/roles/${roleId}/history${buildQuery(params)}`)
}
